import React, {useEffect, useRef, useState} from "react";
import { useLoading } from "../Loading";
import { useAuth } from "../../contexts/authContext";
import { useNavigate } from "react-router-dom";
import { sendChatbot } from "../../utils/api";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import db from "../../firebase/firebaseConfig";

function ChatBot() {
    const {currentUser} = useAuth();
    const {setLoading} = useLoading();
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [messages, setMessage] = useState([]);
    const [dailyMessageCount, setDailyMessageCount] = useState(0);
    const chatBoxRef = useRef(null);
    const [suggestedQuestions] = useState([
        "How often should I feed my pet?",
        "How often should I bathe my pet?",
        "How do I introduce a new pet to my existing pets?",
    ]);

    useEffect(() => {
        if (!currentUser) {
            navigate('/login');
            return;
        }

        const fetchChatHistory =async()=>{
            try {
                setLoading(true);
                const messagesRef = collection(db, 'messageHistory', currentUser.uid, 'messages');
                const messagesQuery = query(messagesRef, orderBy('timestamp', 'asc'));
                const messagesSnapshot = await getDocs(messagesQuery);

                const history = messagesSnapshot.docs.map((doc) => doc.data());
                setMessage(history);
            } catch (error) {
                console.error("Error fetching chat history:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchChatHistory();
        console.log(messages);
         // Reset daily message count at midnight
         const now = new Date();
         const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
         const timeUntilMidnight = midnight.getTime() - now.getTime();
         const timeoutId = setTimeout(() => {
             setDailyMessageCount(0);
         }, timeUntilMidnight);
 
         return () => clearTimeout(timeoutId);

    }, [currentUser]);

    useEffect(() => {
        // Scroll to bottom when messages change
        if (chatBoxRef.current) {
            chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        }
    }, [messages]);


    const handleSendMessage = async() =>{
        if(!input.trim()) return;

        if (dailyMessageCount >= 5) {
            setMessage((prevMessages) => [...prevMessages, { message: "Daily message limit exceeded.", sender: 'bot' }]);
            setInput('');
            return;
        }

        const newMessages = { message: input, sender: 'user' };
        setDailyMessageCount((prevCount) => prevCount + 1);
        
        setMessage((prevMessages) => [...prevMessages, newMessages]);
        setInput('');
        try {
            const botResponse = await sendChatbot(currentUser.uid, input);
            setMessage((prevMessages) => [...prevMessages, { message: botResponse, sender: 'bot' }]);
        } catch (error) {
            console.log('Chatbot error: ', error);
            setMessage([...messages, {message:input, sender:'user'}, {message:'Sorry, I encountered an error. Please try again.', sender:'bot'}]);
        }
    }

    const handleSuggestedQuestionClick = (question) => {
        setInput(question);
        handleSendMessage();
    };

    return (
        <div className="chat-container">
            <div className="chat-box" ref={chatBoxRef}>
                {messages.length === 0 && (
                    <div>
                        <h2 style={{marginTop:"20px"}}>What can I help you?</h2>
                        <div class="div-suggestions">
                            <div class="div-suggestion">
                            <h2 style={{fontSize:"20px"}}>Suggest Questions</h2>
                                {suggestedQuestions.map((question, index) => (
                                    <li key={index} onClick={() => handleSuggestedQuestionClick(question)}>
                                        {question}
                                    </li>
                                ))}
                            </div>
                        </div>
                        <p style={{marginTop:"1px",padding:"0", fontSize:"14px", justifySelf:"center", color:"#6e6e6e"}}>Please note: You can send up to 5 messages per day.</p>
                    </div>
                )}

                {messages.map((msg, index)=>(
                    <p key={index} className={msg.sender}>{msg.message}</p>
                ))}
            </div>
            <div className="input-box">
                <textarea type="text" value={input} onChange={(e)=>setInput(e.target.value)} placeholder="Type a question..."></textarea>
                <button onClick={handleSendMessage}>Send</button>
            </div>

        </div>
    );
}

export default ChatBot;